import apiClient from '@/services/axios'
import moment from 'moment'

export const uploadConsent = async (name, file) => {
  const formData = new FormData()
  formData.append('name', name)
  formData.append('upload', file)

  try {
    const res = await apiClient.post('/upload/consent', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const uploadLabImage = async (name, file) => {
  const formData = new FormData()
  formData.append('name', name)
  formData.append('upload', file)

  try {
    const res = await apiClient.post('/upload/lab-result', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}

export const uploadLabResult = async (testLabId, linkUrl) => {
  try {
    const res = await apiClient.post('/testLabEvidence', {
      testLabId,
      urls: [linkUrl.data],
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const createLabTest = async (testLabTypeId, patientId) => {
  try {
    const res = await apiClient.post('/testLab/self-test', {
      testLabTypeId,
      patientId,
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const uploadResepImage = async (name, file) => {
  const formData = new FormData()
  formData.append('name', name)
  formData.append('upload', file)

  try {
    const res = await apiClient.post('/upload/prescription', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const uploadWeightImage = async (name, file) => {
  const formData = new FormData()
  formData.append('name', name)
  formData.append('upload', file)

  try {
    const res = await apiClient.post('/upload/enhertu', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const uploadResepResult = async (programId, linkUrl, weightUrl, pharmacyId) => {
  try {
    const payload = {
      url: linkUrl.data,
      programId,
      weightUrl: weightUrl ? weightUrl.data : '',
    }
    if (pharmacyId) {
      payload.pharmacyId = pharmacyId
    }
    const res = await apiClient.post('/programEvidence', payload)
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const getListDoctor = async programType => {
  const res = await apiClient.get('/doctor/type/' + programType)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getListProgramType = async id => {
  const res = await apiClient.get('/programType')
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getListProgramTypeById = async id => {
  const res = await apiClient.get('/programType/' + id)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getPatientProgram = async code => {
  const res = await apiClient.get('/patient/code/' + code)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getMigrationBanners = async programTypeIds => {
  if (!Array.isArray(programTypeIds) || programTypeIds.length === 0) {
    return []
  }

  const responses = await Promise.all(
    programTypeIds.map(async programTypeId => {
      try {
        const res = await apiClient.get('/bannerMigrate/' + programTypeId)
        const data = res?.data

        if (!data?.shouldShow || !Array.isArray(data.data)) {
          return []
        }

        return data.data
      } catch {
        return []
      }
    }),
  )

  const seenBanners = new Set()
  return responses.flat().filter(banner => {
    const bannerKey = [
      banner?.title,
      banner?.header,
      banner?.content,
      banner?.footer,
      banner?.showDate,
    ].join('|')

    if (seenBanners.has(bannerKey)) {
      return false
    }

    seenBanners.add(bannerKey)
    return true
  })
}
export const getPatientMaster = async id => {
  const res = await apiClient.get('/npsMaster')
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getPatientNps = async id => {
  const res = await apiClient.get('/npsPatient/patient/' + id)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const createPatientNps = async (payload, patientId, isSkip) => {
  const res = await apiClient.post('/npsPatient', { responses: payload, patientId, isSkip })
  if (res) {
    return res.dat
  } else {
    return []
  }
}
export const createProgram = async (patientId, doctorId, programTypeId, consent, category) => {
  const res = await apiClient.post('/program', {
    patientId,
    doctorId,
    programTypeId,
    consent,
    category: category === 'aurora' ? category : null,
  })
  if (res) {
    return res.data
  } else {
    return []
  }
}

export const updateTestLab = async (programId, testLabId) => {
  const res = await apiClient.post('/program/updateTestLab', {
    id: programId,
    testLabId,
  })
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const confirmProgram = async (programId, confirmationCode) => {
  const res = await apiClient.post('/program/confirm', {
    id: programId,
    confirmationCode,
  })
  return res.data
}

export const testLabTypeList = async () => {
  const res = await apiClient.get('/testLabType')
  if (res) {
    return res.data
  } else {
    return []
  }
}

export const getSurvey = async programTypeId => {
  const res = await apiClient.get('/survey/question', { params: { programTypeId } })
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const submitSurvey = async (answerId, patientId) => {
  const res = await apiClient.post('/survey/submit', { patientId, answerId })
  if (res) {
    return res.data
  } else {
    return []
  }
}

export const uploadInsuranceImage = async (name, file) => {
  const formData = new FormData()
  formData.append('name', name)
  formData.append('upload', file)

  try {
    const res = await apiClient.post('/upload/certificate', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}

export const uploadInsuranceResult = async (testLabId, linkUrl) => {
  try {
    const res = await apiClient.post('/insurance', {
      testLabId,
      urls: [linkUrl.data],
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const updateProgramInsurance = async (id, insuranceId) => {
  try {
    const res = await apiClient.post('/program/updateInsurance', {
      id,
      insuranceId,
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}

export const uploadKwitansiImage = async (name, file) => {
  const formData = new FormData()
  formData.append('name', name)
  formData.append('upload', file)

  try {
    const res = await apiClient.post('/upload/redemption', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const uploadKwitansiResult = async (programId, linkUrl) => {
  try {
    const payload = {
      url: [linkUrl.data],
      programId,
    }
    const res = await apiClient.post('/medicalRedemption', payload)
    // await apiClient.post('/medicalRedemption/validate' + `/${res.data[0].id}`)
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const getFarmasi = async city => {
  try {
    const res = await apiClient.get('/pharmacy', {
      params: city
        ? {
            city,
          }
        : {},
    })
    // await apiClient.post('/medicalRedemption/validate' + `/${res.data[0].id}`)
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const getFarmasiProvince = async () => {
  try {
    const res = await apiClient.get('/pharmacy/province')
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const getFarmasiCity = async province => {
  try {
    const res = await apiClient.get('/pharmacy/city/', {
      params: {
        province,
      },
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const getTransaksi = async (programId, linkUrl) => {
  try {
    const payload = {
      // url: [linkUrl.data],
      programId,
    }
    const res = await apiClient.get('/medicalRedemption', payload)
    // await apiClient.post('/medicalRedemption/validate' + `/${res.data[0].id}`)
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const verifikasiTransaksi = async id => {
  try {
    const res = await apiClient.post(`/medicalRedemption/validate/${id}`)
    // await apiClient.post('/medicalRedemption/validate' + `/${res.data[0].id}`)
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const getSurveyResult = async patientId => {
  try {
    const res = await apiClient.get('/survey/submit', { params: { patientId } })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}

export const checkDailyReminder = async (hour, minute, patientId, programTypeName) => {
  try {
    const res = await apiClient.post('/pillsTaken/add', {
      hour,
      minute,
      patientId,
      programTypeName,
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const continueProgram = async programId => {
  try {
    const res = await apiClient.post('/program/continue', {
      id: programId,
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const terminateProgram = async (programId, message) => {
  try {
    const res = await apiClient.post('/program/terminate', {
      id: programId,
      message,
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}
export const getTerminateReason = async () => {
  try {
    const res = await apiClient.get('/report/program/terminate')
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}

export const getHistoryDrugsReminder = async (patientId, drugsTakenDate, medicines) => {
  try {
    const drugDate = moment(new Date(drugsTakenDate))
    var diff = moment().diff(drugDate, 'day')
    // console.log(diff, '<<<<CEk')
    const res = await apiClient.get('/pillsTaken', {
      params: {
        patientId,
        days: diff,
        drugsTakenDate,
        medicines,
        enroll: drugsTakenDate,
      },
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}

export const updateProfile = async (
  dateOfBirth,
  email,
  fullname,
  gender,
  idNumber,
  idPicture,
  representativeName,
  representativePhone,
  representativeRelationship,
  selfiePicture,
  status,
  patientId,
) => {
  try {
    const res = await apiClient.patch(`/patient/${patientId}`, {
      dateOfBirth,
      email,
      fullname,
      gender,
      idNumber,
      idPicture,
      representativeName,
      representativePhone,
      representativeRelationship,
      selfiePicture,
      status,
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}

export const updatePassword = async (oldPassword, newPassword) => {
  try {
    const userData = JSON.parse(localStorage.getItem('userData'))
    // console.log(userData, 'userData')
    const res = await apiClient.post('/auth/change-password', {
      newPassword,
      oldPassword,
      role: userData.user.role,
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}

export const uploadKtpImage = async (name, file) => {
  const formData = new FormData()
  formData.append('name', name)
  formData.append('upload', file)

  try {
    const res = await apiClient.post('/upload/id', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}

export const uploadSelfieImage = async (name, file) => {
  const formData = new FormData()
  formData.append('name', name)
  formData.append('upload', file)

  try {
    const res = await apiClient.post('/upload/selfie', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return res
  } catch (error) {
    console.error('Upload failed:', error)
    return []
  }
}

export const getListNews = async () => {
  const res = await apiClient.get('/news')
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getListNewsByProgram = async programType => {
  const res = await apiClient.get(`/news/category/program?tag=${programType}`)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getAllTagNews = async () => {
  const res = await apiClient.get('/news/category/getAllTags')
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getListNewsById = async id => {
  const res = await apiClient.get('/news/' + id)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getVideo = async id => {
  const res = await apiClient.get('/videoVertical')
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getHelp = async id => {
  const res = await apiClient.get('/help')
  if (res) {
    return res.data
  } else {
    return []
  }
}

export const getListNotification = async id => {
  const res = await apiClient.get('/notification/' + id)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getListPharmacyNotification = async id => {
  const res = await apiClient.get('/pharmacyNotification/' + id)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getAllProgram = async programId => {
  const res = await apiClient.get('/program', {
    params: {
      program: programId,
      status: 1,
    },
  })
  // console.log(res, 'inidistore')
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getProgramById = async programId => {
  const res = await apiClient.get('/program/' + programId)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const updateDrugsTaken = async programId => {
  const res = await apiClient.post('/program/updateDrugsTaken', {
    id: programId,
  })
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getAllProgramApproved = async () => {
  const res = await apiClient.get('/program/approved')
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getAllProgramHistory = async () => {
  const res = await apiClient.get('/program/history')
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getPendingProgram = async programId => {
  const res = await apiClient.get('/program', {
    params: {
      program: programId,
      status: 1,
      checkpoint: 4,
    },
  })
  // console.log(res, 'inidistore')
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getPrice = async programId => {
  const res = await apiClient.get('/price/list/programType', {
    params: {
      programTypeId: programId,
    },
  })
  // console.log(res, 'inidistore')
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const approveProgram = async payload => {
  const res = await apiClient.post('/program/approve', payload)
  // console.log(res, 'inidistore')
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const sendEmailVerification = async email => {
  const res = await apiClient.get('/patient/account/validatemail/' + email)
  if (res) {
    return res.data
  } else {
    return []
  }
}
